namespace $ {
	export class $shm_hitalama_chat_room extends $giper_baza_entity.with({

		Messages: $giper_baza_list_link.to( ()=> $shm_hitalama_chat_message ),

	}){

		send( text: string ) {
			const profile = $shm_hitalama_profile.current()!
			const message = this.Messages(null)?.make( null )!
			message.author( profile.Login()?.val()! )
			message.time( new $mol_time_moment().valueOf() )
			message.text( text )
			return message
		}

		send_ai( text: string ) {
			const message = this.Messages(null)?.make( null )!
			message.author( 'AI-агент' )
			message.time( new $mol_time_moment().valueOf() )
			message.text( text )
			return message
		}
		
	}
}
